// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as NextBadge from "../../resources/feedback-indicators/NextBadge.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let values = [
  "Daily",
  "Monthly",
  "Yearly"
];

function toLabel(pluralOpt, value) {
  let plural = pluralOpt !== undefined ? pluralOpt : false;
  switch (value) {
    case "Daily" :
      if (plural) {
        return I18n.t("cash_register_report.kind.daily_plural");
      } else {
        return I18n.t("cash_register_report.kind.daily");
      }
    case "Monthly" :
      if (plural) {
        return I18n.t("cash_register_report.kind.monthly_plural");
      } else {
        return I18n.t("cash_register_report.kind.monthly");
      }
    case "Yearly" :
      if (plural) {
        return I18n.t("cash_register_report.kind.yearly_plural");
      } else {
        return I18n.t("cash_register_report.kind.yearly");
      }
  }
}

function toString(value) {
  switch (value) {
    case "Daily" :
      return "daily";
    case "Monthly" :
      return "monthly";
    case "Yearly" :
      return "yearly";
  }
}

function fromString(value) {
  return values.find(current => toString(current) === value);
}

function fromRaw(value) {
  if (value === "daily") {
    return "Daily";
  } else if (value === "monthly") {
    return "Monthly";
  } else {
    return "Yearly";
  }
}

function toNextBadgeKind(value) {
  switch (value) {
    case "Daily" :
      return "Brand";
    case "Monthly" :
      return "Information";
    case "Yearly" :
      return "Danger";
  }
}

let make = React.memo(props => {
  let value = props.value;
  return JsxRuntime.jsx(NextBadge.make, {
    kind: toNextBadgeKind(value),
    label: toLabel(undefined, value),
    size: "L"
  });
});

let Badge = {
  toNextBadgeKind: toNextBadgeKind,
  make: make
};

let Kind = {
  values: values,
  toLabel: toLabel,
  toString: toString,
  fromString: fromString,
  fromRaw: fromRaw,
  Badge: Badge
};

let values$1 = [
  "Open",
  "Closed",
  "Archived"
];

function fromDates(closedAt, archivedAt) {
  if (archivedAt !== undefined) {
    return "Archived";
  } else if (closedAt !== undefined) {
    return "Closed";
  } else {
    return "Open";
  }
}

function toLabel$1(value) {
  switch (value) {
    case "Open" :
      return I18n.t("cash_register_report.status.open");
    case "Closed" :
      return I18n.t("cash_register_report.status.closed");
    case "Archived" :
      return I18n.t("cash_register_report.status.archived");
  }
}

function toString$1(value) {
  switch (value) {
    case "Open" :
      return "open";
    case "Closed" :
      return "closed";
    case "Archived" :
      return "archived";
  }
}

function fromString$1(value) {
  return values$1.find(current => toString$1(current) === value);
}

function toNextBadgeKind$1(value) {
  switch (value) {
    case "Open" :
      return "Important";
    case "Closed" :
      return "Success";
    case "Archived" :
      return "Neutral";
  }
}

function toNextBadgeIcon(value) {
  switch (value) {
    case "Open" :
      return "Hourglass";
    case "Closed" :
      return "Tick";
    case "Archived" :
      return "Archive";
  }
}

let make$1 = React.memo(props => {
  let __size = props.size;
  let value = props.value;
  let size = __size !== undefined ? __size : "L";
  return JsxRuntime.jsx(NextBadge.make, {
    kind: toNextBadgeKind$1(value),
    label: toLabel$1(value),
    size: size,
    icon: toNextBadgeIcon(value)
  });
});

let Badge$1 = {
  toNextBadgeKind: toNextBadgeKind$1,
  toNextBadgeIcon: toNextBadgeIcon,
  make: make$1
};

let Status = {
  values: values$1,
  fromDates: fromDates,
  toLabel: toLabel$1,
  toString: toString$1,
  fromString: fromString$1,
  Badge: Badge$1
};

function nameLabel(name) {
  return I18n.t("No.") + name;
}

function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function monthLabel(date) {
  return capitalize(I18n.dateTimeFormat(undefined, undefined, undefined, "numeric", "long", undefined, undefined, undefined, undefined, date));
}

function yearLabel(date) {
  return I18n.dateTimeFormat(undefined, undefined, undefined, "numeric", undefined, undefined, undefined, undefined, undefined, date);
}

function timeLabel(date) {
  return I18n.template(I18n.t("at {{time}}"), {
    time: DateHelpers.formateToShortTime(undefined, date)
  }, undefined);
}

function closingLabels(kind, openedAt, closedAt) {
  let label;
  switch (kind) {
    case "Daily" :
      label = DateHelpers.formateToShortDate(closedAt);
      break;
    case "Monthly" :
      label = monthLabel(openedAt);
      break;
    case "Yearly" :
      label = yearLabel(openedAt);
      break;
  }
  return [
    label,
    timeLabel(closedAt)
  ];
}

function salesReceiptNameRangeLabel(names) {
  let match = names[0];
  let match$1 = names[names.length - 1 | 0];
  if (match !== undefined) {
    if (match$1 !== undefined && names.length > 1) {
      return match + ` → ` + match$1;
    } else {
      return match;
    }
  }
}

export {
  Kind,
  Status,
  nameLabel,
  capitalize,
  monthLabel,
  yearLabel,
  timeLabel,
  closingLabels,
  salesReceiptNameRangeLabel,
}
/* make Not a pure module */
